/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Table, Badge, Form, Dropdown, Button, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {
  BiDotsHorizontalRounded,
  BiSearch,
  BiSort,
  BiChevronRight,
} from "react-icons/bi";
import moment from "moment";
import { CgSortAz } from "react-icons/cg";
import { FcFinePrint } from "react-icons/fc";

import { toast } from "react-toastify";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  SORT_ORDER_DESC,
  FORM_BUILDER_LISTING_URL,
  RISKSTATUS,
} from "../../../core/constants/common";
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import { RegulationContext } from "../../../App";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import nodataimg from "../../../images/nodatafound.png";
import Utils from "../../../core/utilities/Utils";
import ProfileService from "../../../core/service/ProfileService";

function AlertList({ t }) {
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [searchKey, setSearchKey] = useState("");
  const [show, setShow] = useState(false);
  const [editAlert, setEditAlert] = useState("");
  const [alerts, setAlerts] = useState([]);
  const [desc, setDesc] = useState("");
  const [assignto, setAssignto] = useState("");
  const [users, setUsers] = useState([]);
  const [endDate, setEndDate] = useState(new Date());
  const [totalAlerts, setTotalALerts] = useState("");
  const [profileData, setProfileData] = useState({});
  const [validated, setValidated] = useState(false);

  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  var authToken = localStorage.getItem("accessToken");
  var data = JSON.parse(localStorage.getItem("authority"));
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const glbRegulationCode = glbRegulation?.code ? glbRegulation.code : "";
  var lsDat = JSON.parse(localStorage.getItem("authority"));
  const companyId = lsDat.profile.company.id;
  var string = "";
  var profileId = "";
  var encodedParam = "";
  const userObj = {
    type: lsDat.roles.includes('SUPPLIER_ADMIN') ? 'SUPPLIER_ADMIN' : 'SUBSCRIBER_ADMIN',
    id: lsDat.roles.includes('SUPPLIER_ADMIN') ? lsDat.profile.company.id : 0,
  };

  // else if (userObj === "SUBSCRIBER_ADMIN") {
  // }
  if (userObj.type === "SUPPLIER_ADMIN" && glbRegulationId) {
    profileId = userObj.id;
    const string = Utils.generateUrlParamCompanyRegulationWithSupplier(
      companyId,
      glbRegulationId,
      profileId
    );
    encodedParam = Utils.encodeBase64(string);
  }

  useEffect(() => {
    if (userObj.type === "SUPPLIER_ADMIN" && glbRegulationId) {
      getProfileData(encodedParam);
    }
    listAlerts(0, itemsPerPage, searchKey, sortField);
  }, [glbRegulationId]);


  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    listAlerts(0, itemsPerPage, searchKey, val);
  };
  const handleSearch = (e) => {
    listAlerts(0, itemsPerPage, searchKey, sortField);
  };

  const handleClose = () => {
    setShow(false);
  };
  const getProfileData = async (encodedParam) => {
    ProfileService.getProfileData(encodedParam)
      .then((response) => {
        setProfileData(response.data);
      })
      .catch((error) => {
      });
  };
  const handleSubmit = (alert) => {
    if (!desc || !alert.createdDate || !assignto) {
      setShow(true);
    } else {
      let param = {
        title: "",
        description: desc,
        startDate: alert.createdDate,
        dueDate: endDate,
        assignees: [{ id: assignto }],
      };
      CompanyDashboardService.convertAlerttoTask(param, alert.id)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setShow(false);
            listAlerts(currentPage, itemsPerPage, searchKey, sortField);
          }

        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
        });
    }
    setValidated(true);
  };
  const handleClick = (item) => {
    setDesc(item.message);
    getAssignto();
    setEditAlert(item);
    setShow(true);
  };
  const listAlerts = (
    pageNumber,
    itemsPerPageVal,
    searchVal = "",
    sortField
  ) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    var sort = sortField + "," + order;
    if (profileId) {
      CompanyDashboardService.listSupplierAlerts(
        encodedParam,
        glbRegulationCode,
        pageNumber,
        perPage,
        sort,
        order,
        searchVal,
      )
        .then((response) => {
          let count = parseFloat(response.headers["x-total-count"]);
          setTotalALerts(count);
          setAlerts([...response.data]);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
        });
    } else {
      CompanyDashboardService.listAlerts(
        glbRegulationCode,
        pageNumber,
        perPage,
        sort,
        order,
        searchVal
      )
        .then((response) => {
          var totalPages = parseFloat(response.headers["x-total-count"]);
          setItemTotalCount(totalPages);
          setAlerts([...response.data]);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);

        });
    }
  };
  const getAssignto = (key = "") => {
    CompanyDashboardService.getUsers(key)
      .then((response) => {
        setUsers([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);

      });
  };
  const filterBy = () => true;

  return (
    <>
      <div className="FormsList">
        <div className="List_header">
          {userObj.type === "SUPPLIER_ADMIN" ? (
            <h5 className="MH">
              <Link
                to={`/company_admin/supplier_profile/${profileData?.supplier?.id}`}
                className="Search_iocnBox"
              >
                {profileData?.supplier?.legalName}
              </Link>
              <BiChevronRight />

              {t("Alerts.label")}
            </h5>
          ) : (
            <h5 className="MH">
              <Link to="/company_admin/dashboard" className="Search_iocnBox">
                {t("Home.label")}
              </Link>
              <BiChevronRight />
              {t("Alerts.label")}
            </h5>
          )}
        </div>

        <div className="List_Table_01">
          <div className="List_table-card01_head">
            <div className="List_table-card_Search_01">
              <div className="List_table-card_Search_Box">
                <Form>
                  <input
                    type="text"
                    className="form-control"
                    value={searchKey}
                    onChange={handleSearch}
                  />
                  <Link to="#" className="Search_iocnBox">
                    <BiSearch />
                  </Link>
                </Form>
              </div>
            </div>
            <div className="List_table-card01_sort">
              <ul>
                {/* <li>
                   <Link to="#">
                     <BiShareAlt /> {t("Share.label")}
                   </Link>
                 </li> */}
                <li className="filter">
                  <Link to="#">
                    <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th className="th_check">
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("message")}>
                      {t("Message.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>{t("CompanyName.label")}</th>

                  <th>
                    <Link to="#" onClick={() => handleSort("createdDate")}>
                      {t("CreatedDate.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("priority")}>
                      {t("Risk.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {alerts?.length > 0 ? (
                  alerts?.map((item, index) => (
                    <tr key={item.id}>
                      <td className="checkbox">
                        {" "}
                        <Form.Check
                          inline
                          name="group1"
                          type="checkbox"
                          id="inline-checkbox-1"
                        />
                      </td>
                      <td>{item.message}</td>
                      <td>{item.sourceCompany.legalName}</td>
                      <td>
                        {" "}
                        {moment(item.createdDate).format("MMM DD, YYYY")}
                      </td>
                      <td>
                        {(() => {
                          switch (item.priority) {
                            case "HIGH":
                              return (
                                <Badge bg="badge-High">
                                  {RISKSTATUS[item.priority]}
                                </Badge>
                              );
                            case "MEDIUM":
                              return (
                                <Badge bg="badge-Medium">
                                  {RISKSTATUS[item.priority]}
                                </Badge>
                              );
                            case "LOW":
                              return (
                                <Badge bg="badge-Low">
                                  {RISKSTATUS[item.priority]}
                                </Badge>
                              );
                            default:
                              return " ";
                          }
                        })()}
                      </td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="blank_outline"
                            id="dropdown-basic"
                          >
                            <BiDotsHorizontalRounded />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item>
                              {t("TakeAnAction.label")}
                            </Dropdown.Item>
                            <Dropdown.Item>
                              {t("Dismiss.label")}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="p-2 List_footer_count">
              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  listAlerts(pageNum, perPage, searchKey, sortField);
                }}
              />
            </div>
          </div>
        </div>
        <Modal
          show={show}
          onHide={handleClose}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            < Modal.Title as="h5">{t("TakeanAction.label")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form noValidate validated={validated}>
              <div className="Single_RC_01">
                <div className="Single_RC_Row01 m-0">
                  <div className="p-2">
                    <label className="mb-1">{t("Title.label")}</label>
                    <textarea
                      className="form-control"
                      required
                      onChange={(e) => setDesc(e.target.value)}
                      defaultValue={editAlert.message}
                    ></textarea>
                  </div>

                  <div className="p-2">
                    <label className="mb-1">{t("Assignto.label")}</label>
                    <Typeahead
                      filterBy={filterBy}
                      id="assignto"
                      options={users}
                      placeholder={t("Search.label")}
                      labelKey="name"
                      onChange={(selected) => {
                        if (selected[0]) {
                          setAssignto(selected[0].id);
                        }
                      }}
                      inputProps={{ required: true }}
                    ></Typeahead>
                  </div>
                  <div className="p-2">
                    <label className="mb-1">{t("EndDate.label")}</label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      className="form-control"
                      required
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </div>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Cancel.label")}
            </Button>
            <Button variant="primary" onClick={() => handleSubmit(editAlert)} className="sbmBtn">
              {t("Create.label")}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
AlertList.propTypes = {};

export default withTranslation()(AlertList);
